import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editroutelist',
  template: require('./editroutelist.component.html'),
  styles: [],
})
export class EditRouteListComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit() {
  }


}
